import { useState } from 'react';
import { Search, MapPin, Calendar, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import bg from '../asset/YTDown.com_YouTube_Recording-2025-11-20-134326_Media_YXFKIM7hIyc_002_360p.mp4';

export default function Hero() {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/tours?search=${searchQuery}`);
    }
  };

  return (
    <section className="relative overflow-hidden pt-20 pb-32">
      <video
        autoPlay
        muted
        loop
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src={bg} type="video/mp4" />
      </video>

      <div className="absolute inset-0 bg-black/50"></div>

      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-80 h-80 bg-orange-200 dark:bg-orange-900/20 rounded-full blur-3xl opacity-20"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-orange-100 dark:bg-orange-900/10 rounded-full blur-3xl opacity-20"></div>

      <div className="container relative z-10">
        {/* HEADER TEXT — smaller, cleaner */}
                     <div className="grid grid-cols-3 mt-4 md:py-6  gap-2 text-xs">
             
            </div>
        <div className="text-center mb-5">
          <h1 className="text-3xl md:text-4xl font-bold mb-2 text-white tracking-tight">
            <span className="bg-gradient-to-r from-green-300 to-green-400 bg-clip-text text-transparent font-serif">
              YS SKY TRAVEL & TOUR AGENCY P.L.C
            </span>
          </h1>

          <p className="text-lg md:text-xl text-gray-200 font-light font-serif">
            Travel Beyond Limits.
          </p>
        </div>

        {/* COMPACT FORM */}
        <div className="max-w-2xl mx-auto">
          <form
            onSubmit={handleSearch}
            className="bg-white dark:bg-slate-800 rounded-xl shadow-xl p-4 md:p-5"
          >
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <div className="md:col-span-2 relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />

                <input
                  type="text"
                  placeholder="Search tours or destinations..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-9 pr-3 py-2.5 text-sm rounded-lg border border-gray-200 dark:border-slate-700 bg-gray-50 dark:bg-slate-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:ring-2 focus:ring-orange-500 dark:focus:ring-orange-400 focus:outline-none"
                />
              </div>

              <button
                type="submit"
                className="btn-primary flex items-center justify-center gap-1 py-2.5 text-sm"
              >
                <Search className="w-4 h-4" />
                <span>Search</span>
              </button>
            </div>

            {/* SMALL FILTER ROW */}
            <div className="grid grid-cols-3 mt-4 pt-4 border-t border-gray-200 dark:border-slate-700 gap-2 text-xs">
              <div className="flex items-center gap-1.5 text-gray-600 dark:text-gray-400">
                <MapPin className="w-3.5 h-3.5 text-orange-500" />
                <span>Any Location</span>
              </div>

              <div className="flex items-center gap-1.5 text-gray-600 dark:text-gray-400">
                <Calendar className="w-3.5 h-3.5 text-orange-500" />
                <span>Anytime</span>
              </div>

              <div className="flex items-center gap-1.5 text-gray-600 dark:text-gray-400">
                <Users className="w-3.5 h-3.5 text-orange-500" />
                <span>Any Group</span>
              </div>
            </div>
             <div className="grid grid-cols-3 mt-4 pt-4 border-t border-gray-200 dark:border-slate-700 gap-2 text-xs">
             
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
